export default "__VITE_ASSET__DHLxxmDF__"